export const feedbackSurfaces = {
  '/app': 'major_page',
  '/app/intake': 'intake',
  '/app/quote': 'quote',
  '/app/approval': 'approval',
  '/app/assignment': 'assignment',
  '/app/proof-review': 'proof_review',
  // Issue #192 permanent Docket #18: the legacy '/app/*' paths above are no longer reachable from
  // the current customer/FenzSafe navigation. '/' and '/fenzsafe' are the real current journeys;
  // keep this in sync with PilotFeedbackService::SURFACES (the backend independently validates the
  // exact same path/step pairing).
  '/': 'process_service',
  '/fenzsafe': 'fenzsafe',
} as const;

export type FeedbackPath = keyof typeof feedbackSurfaces;
export type FeedbackStep = typeof feedbackSurfaces[FeedbackPath];
export type WorkspaceHelpStep = 'mission_control' | 'company_operations' | 'company_staff' | 'server_work_queue' | 'server_signature' | 'customer_workspace' | 'assignment_management' | 'server_roster';
export type FeedbackSurface = {pagePath: FeedbackPath | '/' | '/company/staff' | '/server/signature'; workflowStep: FeedbackStep | WorkspaceHelpStep};

type WorkspaceCapabilities = Partial<Record<'mission_control' | 'company_operations' | 'server_work_queue' | 'attorney_review' | 'company_assignment_management' | 'process_server_onboarding' | 'process_server_roster' | 'onboarding_delivery' | 'company_managed_process_server_enrollment' | 'company_administrator_invitations', boolean>>;

export function feedbackSurfaceForPath(path: string): FeedbackSurface | null {
  const workflowStep = feedbackSurfaces[path as FeedbackPath];
  return workflowStep ? {pagePath: path as FeedbackPath, workflowStep} : null;
}

/** Selects the most useful Holmes Jr. context for the authenticated workspace. */
export function helpSurfaceForWorkspace(path: string, capabilities: WorkspaceCapabilities): FeedbackSurface | null {
  if (path === '/company/staff') return capabilities.company_operations || capabilities.company_administrator_invitations || (capabilities.onboarding_delivery && capabilities.company_managed_process_server_enrollment) ? {pagePath: path, workflowStep: 'company_staff'} : null;
  if (path === '/server/signature' && capabilities.server_work_queue) return {pagePath: path, workflowStep: 'server_signature'};
  if (path !== '/') return feedbackSurfaceForPath(path);
  if (capabilities.mission_control) return {pagePath: '/', workflowStep: 'mission_control'};
  if (capabilities.company_operations) return {pagePath: '/', workflowStep: 'company_operations'};
  if (capabilities.server_work_queue) return {pagePath: '/', workflowStep: 'server_work_queue'};
  if (capabilities.attorney_review) return {pagePath: '/', workflowStep: 'customer_workspace'};
  if (capabilities.company_assignment_management) return {pagePath: '/', workflowStep: 'assignment_management'};
  if (capabilities.process_server_onboarding || capabilities.process_server_roster) return {pagePath: '/', workflowStep: 'server_roster'};
  return null;
}
